import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { Creators as AuthActions, Types as AuthTypes } from 'store/ducks/Auth';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

const saveToken = (accessToken, refreshToken) => {
  sessionStorage.setItem('SISGASREC.ACCESS_TOKEN', accessToken);
  localStorage.setItem('SISGASREC.REFRESH_TOKEN', refreshToken);
};
const saveTypeUser = typeUser => {
  sessionStorage.setItem('SISGASREC.TYPE_USER', typeUser);
};

// eslint-disable-next-line consistent-return
function* login({ payload }) {
  try {
    const { status, data } = yield call(api.post, '/auth/login', payload);
    if (status === 200) {
      if (data.roles.includes('service')) {
        return yield put(
          AuthActions.loginError({
            message:
              'Invalid login, services credentials cannot access the system',
          })
        );
      }
      saveToken(data.token, data.refreshToken);
      saveTypeUser(data.roles);
      if (payload && payload.email) {
        localStorage.setItem('SISGASREC.LAST_EMAIL', payload.email);
        Sentry.setUser({ email: payload.email });
      }
      yield put(AuthActions.setTypeUser(data.roles[0]));
      yield put(AuthActions.loginSuccess(data.user));
    }
    else {
      Sentry.captureMessage('login failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });

    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } })
    yield put(AuthActions.loginError(error.response?.data || { message: 'Network error' }));
  }
}

function* loginWatcher() {
  yield takeLatest(AuthTypes.LOGIN, login);
}

export default function* rootSaga() {
  yield all([fork(loginWatcher)]);
}
